<template>
<div>
    
    <div class="sa-mob-cont">
        <button class="sa-btn-back" @click="$parent.referPhysio=false">
            <i class="icon-arrow-left"></i>
        </button>
        <div class="sa-row sa-d-f-a-center">
            <div class="sa-col-xs12 sa-col-sm7 sa-col-md7 sa-col-lg8">
            <h5 class="sa-card-tit sa-ref-tit">Refer to Physiotherapist</h5>
            </div>
            <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
            <div class="sa-form-group">
                <input v-model="searchName" type="text" class="sa-form-control sa-search-lft" @input="getTreatments()" id="searchName" placeholder="Search Treatment" name="search Name" /><i class="icon-search sa-search-icn"></i>
            </div>
            </div>
        </div>
        <ul v-if="treatments && treatments.length" class="sa-physio-radio sa-mt20">
            <li v-for="(t, i) in treatments" :key="i">
                <input  type="checkbox" v-model="trtmnt_id" :id="i" :name="i" :value="t.trtmnt_id" >
                <label :for="i">{{t.trtmnt_nm}}</label>
            </li>        
            <li class="sa-dialog-white" v-if="loader">
                <img src="../../../../assets/img/loader.svg" alt="loader" class="sa-loader" />
            </li>
        </ul>
        <ul v-if="!(treatments && treatments.length)" class="sa-physio-radio sa-mt20">
            <li>
                <span>No treatments available</span>
            </li>
        </ul>
    </div>
        <div class="sa-mt40 sa-ftr-btn ">
            <button :disabled="loader" @click="referPhysio" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs">Continue</button>
        </div>
    <div v-if="loading">
      <img src="../../../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
    </div>
    </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
export default {
    methods: {
      getTreatments () {
        let _self = this
        _self.$store.dispatch("httpPost", {
            uri: `${pro_url}/refer/treatmentDetails`,
            body: {
                "mtype": 3,  
                "limit": 1000,
                "page": 1,
                "name": _self.searchName,
                 "prd_id":"ST02"
            }
            }).then(response => {
            _self.loading = false
            if (response && response.status === 1000) {
                _self.treatments = response.data.data 
            }
        })
      },
      referPhysio () {
        this.loader = true
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        _self.$store.dispatch('httpPost', {
            uri: `${pro_url}/refer/addTreatmentReferal`,
            body:{
            "apnt_id": _self.patDetails.apnt_id,
            // "pid": _self.patDetails.pid,
            "uid": _self.patDetails.refDoctor || "",
            "pkg_id": _self.patDetails.refPackages || [],
            "tsk_id": _self.patDetails.refNurse || [],
            "tst_id": _self.patDetails.refTests || [],
            stid: _self.patDetails.stid || '',
            dept_id: _self.patDetails.dept_id || '',
            "trtmnt_id": _self.trtmnt_id,
            'radiology':  _self.patDetails.radiology || [],
             "covid": _self.patDetails.covid || [],
             "vitamin_iv_drip": _self.patDetails.vitamin_iv_drip || [],
             "vaccination": _self.patDetails.vaccination || [],
            "hemodialysis": _self.patDetails.hemodialysis || [],
            ref_doctorId : _self.patDetails.ref_doctorId || ''
            }
        }).then(response => {
            _self.loader = false
            if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Referred physio treatments successfully",
                class: "sa-a-success"
            });
            _self.patDetails.refPhysio = _self.trtmnt_id
            _self.$localStorage.set('patDetails', JSON.stringify(_self.patDetails))
            _self.$parent.referPhysio = false            
            _self.$parent.getReferralData();
            } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
                class: "sa-a-danger"
            });
            }
        })

        }
    },
    mounted(){
        this.loading = true
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        _self.getTreatments()
    },
    props:['trtmnt_id'],
    data(){
        return{
            loader: false,
            loading: false,
            reports: 'video',
            treatments: null,
            searchName: ''
        }
    }
}
</script>